
import * as React from 'react';
import EditorProps from '../../components/editorinterface';
import { FormControl } from 'react-bootstrap';
import './index.css'

interface Props extends EditorProps {

};

// Regular Expression from http://emailregex.com/
const mailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class EmailEditor extends React.Component<Props, EmailEditorState> {

	value: null | string;

  constructor(props: Props) {
    super(props);
    this.value = props.value;
    this.onInputChange = this.onInputChange.bind(this);
    this.editorSelected = this.editorSelected.bind(this);
    this.editorBlurred = this.editorBlurred.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.state = {editMode: false};
  }

  public render() {
    const props = this.props;
    const state = this.state;

    return (
      (state.editMode || this.value === null || this.value === '') ?
      <FormControl
      	type="email"
      	value={this.value === null || this.value ===undefined ? "" : this.value}
      	placeholder="Enter email address"
      	onChange={this.onInputChange}
        onBlur={this.editorBlurred}
      	readOnly={!!props.field.readOnly}
        onKeyDown={this.onKeyDown}
        // Autofocus only when clicked, needed to not get focus on loaded page when empty
        autoFocus={!(this.value === null || this.value === '')}
      />
      :
      <div className="form-control mailto-link-container" onClick={this.editorSelected}>
        <a href={`mailto:${props.value}`} onClick={this.editorBlurred}>{props.value}</a>
      </div>
    );
  }

  private onInputChange(e: any) {
    this.value = e.target.value;
		if (this.value === null)
			this.value = '';
    this.setState({editMode:true});
    if (this.value === '' || this.value.match(mailRegex))
      this.props.onChange(this.props.field.id, this.value);
  }

  private editorSelected() {
		if (!this.state.editMode && !this.props.field.readOnly)
			this.setState({editMode:true});
  }

  private editorBlurred() {
		if (this.state.editMode)
    	this.setState({editMode:false});
  }

  private onKeyDown(e: any) {
    if (e.keyCode == 13 || e.keyCode == 27 || e.keyCode == 9) // enter, escape or tab
        this.editorBlurred();
    }
}

type EmailEditorState = {
    editMode: boolean;
}

export default EmailEditor;



// WEBPACK FOOTER //
// ./src/components/emaileditor/index.tsx